module.exports = __webpack_public_path__ + "img/J12325.9fa6d122.png";